export const AUTH_ROLES = {
  COMMERCE_EDITOR: 'COMMERCE_EDITOR',
  COMMERCE_MANAGER: 'COMMERCE_MANAGER',
  INSIGHTS_VIEWER: 'INSIGHTS_VIEWER',
  MEDIA_MANAGER: 'MEDIA_MANAGER',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
};

export const ROLES_BY_GROUP = {
  mikmakProdEng: [
    AUTH_ROLES.SYSTEM_ADMIN,
    AUTH_ROLES.COMMERCE_MANAGER,
    AUTH_ROLES.COMMERCE_EDITOR,
    AUTH_ROLES.MEDIA_MANAGER,
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
  mikmakAdmin: [
    AUTH_ROLES.COMMERCE_MANAGER,
    AUTH_ROLES.COMMERCE_EDITOR,
    AUTH_ROLES.MEDIA_MANAGER,
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
  mikmakCs: [
    AUTH_ROLES.COMMERCE_EDITOR,
    AUTH_ROLES.MEDIA_MANAGER,
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
  mikmak: [
    AUTH_ROLES.COMMERCE_EDITOR,
    AUTH_ROLES.MEDIA_MANAGER,
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
  clientMediaManager: [
    AUTH_ROLES.MEDIA_MANAGER,
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
  client: [
    AUTH_ROLES.INSIGHTS_VIEWER,
  ],
};
